export { default } from './StarsTheme';



// WEBPACK FOOTER //
// ./src/client/js/view/components/StarsTheme/index.js